import { Post } from '@wellesley/openapi'
import { isEqual } from 'lodash/fp'
import { UploadItem } from '@wellesley/uploads'

const compareUploads = (uploads: UploadItem[], feed?: Post) => {
  const mappedLocalUploads = uploads.map((u) => ({
    id: u.preview.split('/').at(-2),
    ...u.meta,
  }))

  const mappedFeedUploads =
    feed?.uploads?.map((u) => ({
      id: u.uploadId,
      ...u.meta,
    })) || []

  return !isEqual(mappedLocalUploads, mappedFeedUploads)
}

export default compareUploads
